import axios from "axios";
import moment from "moment";

function errorHandler(error, reject) {
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  list(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/pphprepaid${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  save(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let resp;
        resp = await axios.post("/pphprepaid", data);
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pasalpph() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/pphprepaid/pasalpph");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  jenispenghasilan() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/pphprepaid/jenispenghasilan");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        str = `?nomor=${encodeURIComponent(
          obj.nomor
        )}&tanggal=${encodeURIComponent(
          moment(obj.tanggal).format("YYYY-MM-DD")
        )}`;
        url = `/buku/printjv`;

        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportcsv(obj = {}) {
    return new Promise((resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        axios({
          url: `/pphprepaid/exportcsv${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "e-faktur-import-Prepaid.csv");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
      try {
        const keys = ["tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        axios({
          url: `/pphprepaid/exportxls${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "pph_prepaid.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  taxgroup() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`/vendor/taxgroup`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
